import React from 'react'
import PropTypes from 'prop-types'
import MarkdownRenderer from 'components/MarkdownRenderer'
import { Spacing50 } from 'styles/sharedStyle'
import { ArticleTextCopy, ArticleTextWrapper } from './Article.style'

const ArticleText = ({ copy, textType, ...props }) => (
  <ArticleTextWrapper isGeneric={textType === 'generic'} {...props}>
    <Spacing50 />
    <ArticleTextCopy as={MarkdownRenderer} html={copy} />
    <Spacing50 />
  </ArticleTextWrapper>
)

ArticleText.propTypes = {
  copy: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  textType: PropTypes.string,
}

ArticleText.defaultProps = {
  copy: '',
  textType: 'editorial',
}

export default ArticleText
